import settings from "../settings/settings";

class LogUtils {

  constructor() {
    this.TAG = "LogUtils";
  }

  logMsg(tag, msg, error) {
    try {

      if (settings.IS_DEBUG_ENABLED) {

        if (error) {
          console.log(`${tag}: ${msg}: ${error}`);
        } else {
          console.log(`${tag}: ${msg}`);
        }
      }

    } catch (err) {
      console.log(`${this.TAG}: unabled to logMsg: ` + err);
    }
  }

  logErrorMsg(tag, msg, error) {
    try {
      this.logMsg(tag, msg, error);

    } catch (err) {
      console.log(`${this.TAG}: unabled to logErrorMsg: ` + err);
    }
  }

}

export default LogUtils;